<template>
  <!-- FOOTER -->
  <footer
    class="
      bg-gray-500
      print:break-inside-avoid-page print:bg-gray-250
    "
  >
    <Container
      tag="div"
      class="
        pb-12 pt-8 text-white
        lg:pb-24 lg:pt-20
        print:text-black
      "
    >
      <div
        class="
          grid
          md:grid-cols-6
          lg:grid-cols-2
        "
      >
        <address
          class="
            mb-6 not-italic
            md:col-span-4
            lg:col-span-1 lg:mb-13
          "
        >
          <a
            class="
              block w-max
              hover:text-red-500
            "
            :href="'link_maps' in data ? data.link_maps : ''"
          >
            <span v-if="'heading' in data" :class="{ 'font-bold': theme === 'nsan' }">{{ data.heading }}</span><br>
            <span v-if="'address' in data" v-html="removePTags(data.address)" /></a>
          <NuxtLink
            v-if="data.phone"
            :to="`tel:${data.phone}`"
            class="
              block w-max
              hover:text-red-500
            "
          >
            {{ data.phone }}
          </NuxtLink>
          <NuxtLink
            v-if="data.email"
            :to="`mailto:${data.email}`"
            class="
              block w-max
              hover:text-red-500
            "
          >
            {{ data.email }}
          </NuxtLink>
        </address>
        <div
          class="
            max-md:mt-4
            md:col-span-2
            lg:col-span-1
          "
        >
          <SocialMedia class="print:hidden" :social-channels="data.social_media_channels" />
          <AppButton
            v-if="data.newsletter_link"
            :to="data.newsletter_link"
            variant="secondary"
            class="mt-6"
          >
            {{ data.newsletter_link_text }}
          </AppButton>
        </div>
      </div>
      <div
        class="
          flex flex-wrap gap-x-12 gap-y-4
          max-lg:mt-8
        "
      >
        <div v-if="data.page_copyright">
          © {{ new Date().getFullYear() }} {{ data.page_copyright }}
        </div>
        <nav>
          <ul
            class="
              flex gap-x-8 gap-y-2
              max-sm:mt-4 max-sm:flex-col
              print:hidden
            "
          >
            <li
              v-for="{ page } in globals?.footer.tree"
              :key="page.id"
              class="
                relative
                [&:nth-child(n+2)]:before:absolute
                [&:nth-child(n+2)]:before:-left-4
                sm:[&:nth-child(n+2)]:before:content-['|']
              "
            >
              <NuxtLink :to="page.url" class="hover:text-red-500">
                {{ page.title }}
              </NuxtLink>
            </li>
          </ul>
        </nav>
      </div>
    </Container>
  </footer>
</template>

<script lang="ts" setup>
const globals = inject(GlobalsKey)!
const data = computed(() => globals.value.general as Extract<typeof globals.value.general, { __typename: 'GlobalSet_General' }>)
const theme = useTheme()
</script>
